import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";
import { useLoginMutation } from "../../features/auth/authApi";
import { useCheckUserRoleQuery } from "../../features/users/usersApi";
import isValidEmail from "../../utils/isValidEmail";

const StudentLogin = () => {
  const navigate = useNavigate();
  const [checkEmail, setCheckEmail] = useState(false)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [login, { isSuccess }] = useLoginMutation();

  const {
    data: userInfo,
    isLoading,
    isError,
    error,
  } = useCheckUserRoleQuery(email, {
    skip: !checkEmail,
  });

  useEffect(() => {
    if(isSuccess) {
      navigate("/lesson");
    }
  },[isSuccess]);

  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...arg) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...arg);
      }, delay);
    };
  };

  const doSearch = (value) => {
    if (isValidEmail(value)) {
      setEmail(value);
      setCheckEmail(true);
    }
  };

  const handleSearch = debounceHandler(doSearch, 1000);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email,
      password,
    };

    login(data);
  };


  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={logo} />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Sign in to Student Account
          </h2>
         <div className="flex justify-center"> <Link to="/admin" className=" mx-auto text-center text-violet-600 font-medium">Switch to admin login</Link></div>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autocomplete="email"
                required
                className="login-input rounded-t-md"
                placeholder="Email address"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div>
              <label for="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                className="login-input rounded-b-md"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          {userInfo?.length === 0 && <Error message="No user found"/>}
          {userInfo?.length > 0 && userInfo[0]?.role !== "student" && (
            <Error message="This email is connected to an admin account"/>
          )}
          <div className="flex items-center justify-between">
            <div className="text-sm">
              <Link
                to="register"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Create new account
              </Link>
            </div>
            <div className="text-sm">
              <Link
                to="/"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Forgot your password?
              </Link>
            </div>
            
          </div>
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              disabled={
                userInfo?.length === 0 ||
                (userInfo?.length > 0 && userInfo[0]?.role !== "student")
              }
            >
              Sign in
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default StudentLogin;
